<template>
    <v-chart ref="map" :options="option"/>
</template>

<script>
    import ECharts from 'vue-echarts'
    import 'echarts/lib/chart/map'
    import chinaJson from 'echarts/map/json/china.json'
    ECharts.registerMap('china',chinaJson);
    export default {
        name: "UserFeatureMapECharts",
        components: {
            'v-chart': ECharts,
        },
        props:{
            mapData:Object
        },
        watch:{
          mapData:function (newVal,oldVal) {
              let maxCount = 0;
              newVal.data.forEach(items=>{
                  if(items.value > maxCount && items.name !== '未知'){
                      maxCount = items.value
                  }
              });
              this.$refs.map.clear();
              this.option.visualMap.max = maxCount;
              this.option.series[0].data = newVal.data;
              this.loaded()
          }
        },
        data(){
            return {
                option: {
                    title:{
                        text: '地域分布',
                        // left:'center'
                        left:'7%'
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: '{b}: {c}',
                    },
                    visualMap: {
                        min: 0,
                        max: 1000,
                        text: ['多', '少'],
                        realtime: false,
                        calculable: true,
                        orient:'horizontal',
                        inRange: {
                            color: ['lightskyblue', 'yellow', 'orangered']
                        },
                        left:'center'
                    },
                    series: [
                        {
                            name: '地域分布',
                            type: 'map',
                            mapType: 'china',

                            data: [
                                // {'name': '黑龙江', 'value': 1192},
                                // {'name': '内蒙古', 'value': 873},
                                // {'name': '河北', 'value': 9974},
                                // {'name': '山西', 'value': 28892},
                                // {'name': '辽宁', 'value': 4908},
                                // {'name': '吉林', 'value': 47543},
                                // {'name': '江苏', 'value': 36080},
                                // {'name': '浙江', 'value': 44435},
                                // {'name': '安徽', 'value': 17053},
                                // {'name': '福建', 'value': 45284},
                                // {'name': '江西', 'value': 31272},
                                // {'name': '山东', 'value': 31227},
                                // {'name': '河南', 'value': 27212},
                                // {'name': '湖北', 'value': 6597},
                                // {'name': '湖南', 'value': 38907},
                                // {'name': '广东', 'value': 32314},
                                // {'name': '海南', 'value': 44805},
                                // {'name': '四川', 'value': 40837},
                                // {'name': '贵州', 'value': 9017},
                                // {'name': '云南', 'value': 31590},
                                // {'name': '陕西', 'value': 19986},
                                // {'name': '甘肃', 'value': 17106},
                                // {'name': '青海', 'value': 16270},
                                // {'name': '台湾', 'value': 47639},
                                // {'name': '内蒙', 'value': 21298},
                                // {'name': '广西', 'value': 39277},
                                // {'name': '西藏', 'value': 8153},
                                // {'name': '宁夏', 'value': 37665},
                                // {'name': '新疆', 'value': 36083},
                                // {'name': '北京', 'value': 11479},
                                // {'name': '天津', 'value': 39464},
                                // {'name': '上海', 'value': 30575},
                                // {'name': '重庆', 'value': 17850},
                                // {'name': '香港', 'value': 38462},
                                // {'name': '澳门', 'value': 1015},
                                // {'name': '南海诸岛', 'value': 873},
                            ]
                        }
                    ]
                }
            }
        },
        methods:{
            loading(){
                this.$refs.map.showLoading()
            },
            loaded(){
                this.$refs.map.hideLoading()
            }
        }
    }
</script>

<style scoped>
    .echarts{
        width: 100%;
        height: 100%;
    }
</style>